import React from 'react';

const AboutPage = () => (
    <div className="" to="/topics">
		AboutPage
    </div>
);

export default AboutPage;